import { Box, Grid } from "@mui/material"

const Hospedajes = () => {
    return (
        <>
            <Grid container flexDirection="row" spacing={1}>
                <Grid item xs={6}>
                    <img src="/images/hospedajes/hotel_ave_paraiso.jpg" style={{ width: '100%' }} />
                </Grid>
                <Grid item xs={6}>
                    <img src="/images/hospedajes/hotel_colonial.jpg" style={{ width: '100%' }} />
                </Grid>
            </Grid>
            <Grid container flexDirection="row" spacing={1}>
                <Grid item xs={6}>
                    <img src="/images/hospedajes/hotel_presidente.jpg" style={{ width: '100%' }} />
                </Grid>
                <Grid item xs={6}>
                    <img src="/images/hospedajes/hotel_selina.jpg" style={{ width: '100%' }} />
                </Grid>
            </Grid>

        </>
    )
}

export default Hospedajes
